import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'
import image from '../../assets/images/post-test@2x.png'

const data = [
  {
    inputType: 'radio',
    question: 'E-cigarettes are mostly just flavored water.',
    options: [
      {
        label: 'True',
      },
      {
        label: 'False',
      },
    ],
  },
  {
    inputType: 'radio',
    question: 'Vaping is harmless.',
    options: [
      {
        label: 'True',
      },
      {
        label: 'False',
      },
    ],
  },
  {
    inputType: 'radio',
    question: 'You can get addicted to nicotine by vaping.',
    options: [
      {
        label: 'True',
      },
      {
        label: 'False',
      },
    ],
  },
  {
    inputType: 'radio',
    question:
      'Both buying and using e-cigarettes is illegal for anyone under the age of 21.',
    options: [
      {
        label: 'True',
      },
      {
        label: 'False',
      },
    ],
  },
]

const correctInput = {
  [data[0].question]: 'False',
  [data[1].question]: 'False',
  [data[2].question]: 'True',
  [data[3].question]: 'True',
}

const feedback = {
  success: {
    title: 'Nice job!',
    body:
      'You have a solid understanding of the potential consequences of vaping and e-cigarette use.  Knowledge is' +
      ' power to a #BeVapeFree generation.  Share it!',
  },
  error: {
    title: 'Almost!',
    body:
      'Misperceptions of vaping are common.  Watch the videos one more time and then try again',
  },
  retry: {
    title: 'Almost!',
    body:
      'Misperceptions of vaping are common.  Watch the videos one more time and then try again',
  },
}

export default {
  title: 'Post Quiz One',
  path: '/post-quiz/post-quiz-one',
  content: (
    <Fragment>
      <Intro
        title="What Do You Think?"
        lead="Now that you have watched the videos, read the following statements and select whether you believe each statement is TRUE or FALSE."
        direction="Select the best answer."
        img={image}
      />
      <MultipleChoice
        data={data}
        feedback={feedback}
        correctInput={correctInput}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Post-Quiz/postQuizOne.js